<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card elevation="3" class="mb-6">
            <v-card-title class="bg-blue-grey-lighten-4">
              <v-icon start>mdi-file-document</v-icon>
              <span class="text-h6">CNC Requisition Details</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <v-row>
                <v-col cols="12" md="6">
                  <strong>Code :</strong> {{ requisition.code }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Date:</strong> {{ requisition.merge_date }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Requested By:</strong>
                  {{ requisition?.created_by?.full_name }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Status: </strong>
                  <v-chip :color="approvalStatus[requisition.pr_status]?.color || 'grey'" variant="outlined"
                    size="small">
                    {{ requisition.pr_status == 1 ? 'Submitted' : 'Draft' }}
                  </v-chip>

                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <!-- Requisition Items -->
          <v-card elevation="3" class="mb-6">
            <v-card-title class="bg-blue-grey-lighten-4">
              <v-icon start>mdi-cart</v-icon>
              <span class="text-h6">Requisition Items</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-data-table :headers="itemHeaders" :items="requisition?.pur_req_merge_details" class="elevation-1"
              density="compact" hide-default-footer>
              <template v-slot:item.index="{ index }">
                {{ ++index }}
              </template>

              <template v-slot:item.itemCode="{ item }">
                {{ item.product?.name || "N/A" }}
              </template>
              <template v-slot:item.unitName="{ item }">
                {{ item.product?.unit?.name || "N/A" }}
              </template>

            </v-data-table>
          </v-card>

          <!-- Approval History -->
          <v-card elevation="3">
            <v-card-title class="bg-blue-grey-lighten-4">
              <v-icon start>mdi-check-decagram</v-icon>
              <span class="text-h6">Approval History</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-data-table :headers="itemHeaders" :items="requisition?.pur_req_merge_details" class="elevation-1"
              density="compact" hide-default-footer>
              <!-- <template v-slot:item.index="{ index }">
                {{ ++index }}
              </template> -->
              <!-- <template v-slot:item.itemCode="{ item }">
                {{ item.product?.name || "N/A" }}
              </template>
              <template v-slot:item.unitName="{ item }">
                {{ item.product?.unit?.name || "N/A" }}
              </template> -->
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField } from "vee-validate";
import { ref } from "vue";
import statusMap from "@/utils/statusMap";
import approvalStatus from "@/utils/approvalStatus";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    statusMap,
    approvalStatus,
    selectedItem: null,
    requisition: {
      code: "",
      date: "",
      department_name: "",
      employee_name: "",
      status: "",
      items: [],
      approvals: [],
    },
    itemHeaders: [
      { title: "#SL", align: "center", key: "index" },
      { title: "Item", align: "center", key: "itemCode" },
      { title: "Qty", align: "center", key: "quantity" },
      { title: "Unit", align: "center", key: "unitName" },
    ],
    approvalHeaders: [
      {
        title: "#SL",
        align: "center",
        key: "index",
      },
      { title: "Step", key: "step", align: "center" },
      { title: "Approver", key: "approval_name", align: "left" },
      { title: "Designation", key: "designation", align: "left" },
      {
        title: "Status",
        key: "status",
        align: "left",
        sortable: true,
      },
      { title: "Remark", align: "left", key: "remarks", sortable: true },
    ],
  }),
  watch: {},
  created() {
    // if (this.$store.getters.getHrmDepartmentList.length === 0) {
      this.$store.dispatch("getHrmDepartmentList");
    // }
    // if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    // }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getPendingPurRequisition;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList;
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList;
    },
  },
  setup() {
    const status = useField("status");
    const remarks = ref("");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    return {
      status,
      remarks,
      errorMessages,
      loading,
    };
  },
  methods: {
    statusColor(status) {
      if (status.includes("Pending")) return "orange";
      if (status.includes("Approved")) return "green";
      if (status.includes("Rejected")) return "red";
      if (status.includes("Hold")) return "Blue";
      return "grey";
    },
    async loadRequisitions(id) {
      try {
        this.$store.commit("SET_LOADING", { color: "primary" });
        this.$store.dispatch("getPurRequisitionMergeById", id).then((data) => {
          let requisition = data;
          this.requisition = requisition;
        });
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        this.$store.commit("UNSET_LOADING");
        console.error("Failed to load requisition:", error);
      }
    },
  },
  mounted() {
    const reqId = this.$route.params.id;
    this.loadRequisitions(reqId);
  },
};
</script>
